module.exports = __webpack_public_path__ + "static/media/roble_original.eb6b90cc.jpg";